import { lazy, Suspense, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { MinimalTopBar } from "@/components/landing-v2/MinimalTopBar";
import { HeroSection } from "@/components/landing-v2/HeroSection";
import { FeaturesQuiet } from "@/components/landing-v2/FeaturesQuiet";
import { PricingQuiet } from "@/components/landing-v2/PricingQuiet";
import { MinimalFooter } from "@/components/landing-v2/MinimalFooter";

// Lazy: AuthModal is only loaded if the user opens it.
const AuthModal = lazy(() =>
  import("@/components/AuthModal").then((m) => ({ default: m.AuthModal }))
);

export default function LandingV2() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    if (searchParams.get("auth") === "true") {
      setAuthOpen(true);
      const next = new URLSearchParams(searchParams);
      next.delete("auth");
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (
    <div className="relative min-h-screen bg-background text-foreground overflow-x-hidden flex flex-col">
      <MinimalTopBar />
      <main className="flex-1">
        <div className="space-y-6 sm:space-y-10 pb-10 sm:pb-14">
          <HeroSection onGetStarted={() => setAuthOpen(true)} />
          <FeaturesQuiet />
          <PricingQuiet />
        </div>
      </main>
      <MinimalFooter />
      {authOpen && (
        <Suspense fallback={null}>
          <AuthModal open={authOpen} onOpenChange={setAuthOpen} />
        </Suspense>
      )}
    </div>
  );
}
